import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Button, ButtonToolbar, Modal } from 'reactstrap';
import { reduxForm } from 'redux-form';

class ModalComponent extends PureComponent {
    static propTypes = {
        title: PropTypes.string,
        message: PropTypes.object,
        color: PropTypes.string.isRequired,
        colored: PropTypes.bool,
        header: PropTypes.bool
    };

    componentDidUpdate () {
    }

    componentDidMount () {
    }

    render () {
        // let Icon;

        // switch (this.props.color) {
        //     case 'primary':
        //         Icon = <span className='lnr lnr-pushpin modal__title-icon' />;
        //         break;
        //     case 'success':
        //         Icon = <span className='lnr lnr-thumbs-up modal__title-icon' />;
        //         break;
        //     case 'warning':
        //         Icon = <span className='lnr lnr-flag modal__title-icon' />;
        //         break;
        //     case 'danger':
        //         Icon = <span className='lnr lnr-cross-circle modal__title-icon' />;
        //         break;
        //     default:
        //         break;
        // }
        return (
            <div>
                {this.props.children}
                <Modal isOpen={this.props.modal} toggle={this.props.toggle}
                    className={`modal-dialog--${this.props.color} ${this.props.colored ?
                        'modal-dialog--colored' : ''} ${this.props.header ? 'modal-dialog--header' : ''}`}>
                    {/* <div className='modal__header'>
                        <span className='lnr lnr-cross modal__close-btn' onClick={this.toggle} />
                        {this.props.header ? '' : Icon}
                        <h4 className='bold-text  modal__title'>{this.props.title}</h4>
                    </div> */}
                    <div className='modal__body'>
                        {this.props.message}
                    </div>
                    <ButtonToolbar className='modal__footer'>
                        <Button onClick={this.props.toggle}>Close</Button>{' '}
                        {/* <Button outline={this.props.colored} color={this.props.color} onClick={this.toggle}>
                    Ok
                    </Button> */}
                    </ButtonToolbar>
                </Modal>
            </div>
        );
    }
}

export default reduxForm({
    form: 'set_frameworks', // a unique identifier for this form
})(ModalComponent);


// WEBPACK FOOTER //
// ./src/components/dashboards/posture-dash/components/FrameworkModal.js